// extracted by mini-css-extract-plugin
module.exports = {"title":"EditPassword_title__XgetP Modal_modalContentTitle__2LL1s","smallTip":"EditPassword_smallTip__OxOkg","tipLink":"EditPassword_tipLink__irwmw"};